import { uniqueNamesGenerator, adjectives, colors, animals } from 'unique-names-generator';

/**
 * Generate a random, memorable name for a peer
 * Format: "Adjective Color Animal" (e.g., "Brave Blue Dolphin")
 */
export function generateRandomName(): string {
  return uniqueNamesGenerator({
    dictionaries: [adjectives, colors, animals],
    separator: ' ',
    style: 'capital',
    length: 3,
  });
}
